import { Controller } from "stimulus";

// Manages the dynamic option rows on the live-poll launch form, enforcing the
// 2-6 bound: the add button hides at the max, and remove buttons hide at the min.
export default class LivePollOptions extends Controller {
  static targets = ["list", "row", "addButton", "removeButton"];
  static values = { min: { type: Number, default: 2 }, max: { type: Number, default: 6 } };

  connect() {
    this.refresh();
  }

  add() {
    if (this.rowTargets.length >= this.maxValue) return;

    const template = this.rowTargets[this.rowTargets.length - 1];
    const clone = template.cloneNode(true);
    clone.querySelectorAll("input").forEach((input) => {
      input.value = "";
    });
    this.listTarget.appendChild(clone);
    this.refresh();
  }

  remove(event) {
    if (this.rowTargets.length <= this.minValue) return;

    event.currentTarget.closest("[data-live-poll-options-target='row']").remove();
    this.refresh();
  }

  // Keep the add/remove affordances in sync with the current row count.
  refresh() {
    const count = this.rowTargets.length;

    if (this.hasAddButtonTarget) {
      // `!hidden` not `hidden`: the plain class loses the cascade to the button's `inline-flex`.
      this.addButtonTarget.classList.toggle("!hidden", count >= this.maxValue);
    }

    this.removeButtonTargets.forEach((button) => {
      button.classList.toggle("invisible", count <= this.minValue);
    });
  }
}
